import styled from 'styled-components';
import dropsWinsIcon from '../assets/drops-wins.svg';

const IconContainer = styled.div`
	position: relative;
	top: -5px;
	left: -5px;
	width: 25px;
	height: 30px;
	overflow: visible;
`;

const Icon = styled.img`
	width: 30px;
	height: 30px;
`;

const DropsWinsPragmatic = () => {
	return (
		<IconContainer>
			<Icon src={dropsWinsIcon} />
		</IconContainer>
	);
};

export default DropsWinsPragmatic;
